import type { BadgeProps } from "@drone-js/core";
import type { PayoutItem } from "libs/codegen/property-onboarding";
import type { FunctionComponent } from "react";
import { RadioButton } from "../../../commons/components/RadioButton";

interface Props {
    title: string;
    badge?: BadgeProps;
    description?: string;
    item: Omit<PayoutItem, "name">;
    value: PayoutItem;
    setValue: (value: PayoutItem) => void;
}

export const NewPayoutRadioButton: FunctionComponent<Props> = ({
    item,
    title,
    description,
    value,
    setValue,
    badge,
}) => {
    const handleSetValue = () => {
        setValue({
            ...item,
            name: title,
        });
    };

    return (
        <RadioButton
            id={`new-payout-radio-${item.method}`}
            title={title}
            titleBadge={badge}
            description={description}
            isSelected={value?.method === item.method}
            setValue={handleSetValue}
        />
    );
};
